import { render, staticRenderFns } from "./SidebarWrapper.vue?vue&type=template&id=0a26be97&"
import script from "./SidebarWrapper.vue?vue&type=script&lang=ts&"
export * from "./SidebarWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarWrapper.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports